module.exports = __webpack_public_path__ + "2fad952a20fbbcfd1bf2ebb210dccf7a.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_element-ui@2.4.11@element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 164
// module chunks = 0